import { TableHead, TableHeader, TableRow } from "@/components/ui/table/table";

export const CampaignTableHeader = () => {
	return (
		<TableHeader>
			<TableRow>
				<TableHead></TableHead>
				<TableHead>名前</TableHead>
				<TableHead>発行日</TableHead>
				<TableHead>利用可能期間</TableHead>
				<TableHead>発行数</TableHead>
				<TableHead>割引金額</TableHead>
				<TableHead>操作</TableHead>
			</TableRow>
		</TableHeader>
	);
};

CampaignTableHeader.displayName = "CampaignTableHeader";
